// extracted by mini-css-extract-plugin
export var modal = "_sr-0";
export var table = "_sr-1";